import {
  ChevronLeftIcon,
  ChevronRightIcon,
  CloseIcon,
  cn,
} from '@playerbase/ui';

type SidebarCollapseToggleProps = {
  collapsed: boolean;
  onToggle: () => void;
  onCloseDrawer?: () => void;
};

// Top-of-sidebar control strip. On desktop it shows a chevron that
// folds/unfolds the sidebar (persisted in localStorage). On mobile the
// chevron is hidden and a close-drawer button takes its place so the
// existing app-shell-drawer test keeps finding the "Close navigation"
// aria-label after we deleted sidebar-logo.tsx.
export function SidebarCollapseToggle({
  collapsed,
  onToggle,
  onCloseDrawer,
}: SidebarCollapseToggleProps): JSX.Element {
  return (
    <div
      className={cn(
        'flex h-12 shrink-0 items-center border-b border-border px-2',
        collapsed ? 'justify-center' : 'justify-end',
      )}
    >
      <button
        type="button"
        onClick={onToggle}
        aria-label={collapsed ? 'Expand navigation' : 'Collapse navigation'}
        title={collapsed ? 'Expand navigation' : 'Collapse navigation'}
        className="hidden md:flex h-7 w-7 items-center justify-center rounded-md text-text-muted transition-colors hover:bg-surface-2 hover:text-text"
      >
        {collapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
      </button>
      {onCloseDrawer !== undefined && (
        <button
          type="button"
          onClick={onCloseDrawer}
          aria-label="Close navigation"
          className="md:hidden flex h-7 w-7 items-center justify-center rounded-md border border-border-strong text-text-muted transition-colors hover:bg-surface-2 hover:text-text"
        >
          <CloseIcon />
        </button>
      )}
    </div>
  );
}
